import api from './api';

// Hotels
export const createHotel = (data) => api.post('/hotels', data).then(r => r.data);
export const updateHotel = (id, data) => api.patch(`/hotels/${id}`, data).then(r => r.data);
export const deleteHotel = (id) => api.delete(`/hotels/${id}`).then(r => r.data);

// Temples
export const createTemple = (data) => api.post('/temples', data).then(r => r.data);
export const updateTemple = (id, data) => api.patch(`/temples/${id}`, data).then(r => r.data);
export const deleteTemple = (id) => api.delete(`/temples/${id}`).then(r => r.data);

// Ghats
export const createGhat = (data) => api.post('/ghats', data).then(r => r.data);
export const updateGhat = (id, data) => api.patch(`/ghats/${id}`, data).then(r => r.data);
export const deleteGhat = (id) => api.delete(`/ghats/${id}`).then(r => r.data);

// Pandits
export const createPandit = (data) => api.post('/epuja/pandits', data).then(r => r.data);
export const updatePandit = (id, data) => api.put(`/epuja/pandits/${id}`, data).then(r => r.data);
export const deletePandit = (id) => api.delete(`/epuja/pandits/${id}`).then(r => r.data);
